import React from "react";
import matchMeista from "../../../../imgs/MatchMeista.svg";
import job4uLogo from "../../../../imgs/job4u_ev_Logo.png";

const LogoJobmatrix = () => (
  <div className="borderheadline">
    {/* Ein Verweis mit Bild, keine Ueberschrift: als h2 stand das Logo in der
        Gliederung als Zwischentitel ohne Text (Audit 2026-10-07, B5). Die
        Gestalt haengt an .main-logo (_header.scss). */}
    <div className="main-logo">
      <a href="/">
        {" "}
        <img src={matchMeista} alt="Match Meista" />
      </a>
    </div>

    <div className="sub-logo">
      <img src={job4uLogo} alt="Job4u Logo" />
    </div>
  </div>
);

export default LogoJobmatrix;
